<div class="bmc-sync-data__wrapper">
  <div class="bmc-syncdata-import-step0">
    <h2 class="bmc-syncdata-import-step0__title">{{ 'SYNC_DATA.SELECT_FILE_TO_IMPORT' | translate}}</h2>
    <div class="bmc-syncdata-import-step0__file-selection">
      <bzg-input type="text" class="bmc-syncdata-import-step0__file-selection__file-path" [(ngModel)]="data.syncData.FilePath" placeholder="{{ ('SYNC_DATA.FILE_NAME' | translate)}}"></bzg-input>
      <bzg-button-primary class="bmc-syncdata-import-step0__browse" type="button" (click)="addFiles()">{{ 'SYNC_DATA.BUTTON_BROWSE' | translate}}</bzg-button-primary>
      <input #fileUpload [id]="'import-file-input'" type="file" (change)="onFilesAdded()" [hidden]="true" accept=".bdex" filters=".bdex">
    </div>
    <div class="bmc-syncdata-import-step0__override-localiation">
      <bzg-checkbox id="checkOverrideLocalization" class="bs-modal-fonts__checkbox" [checked]="data.syncData.OverrideTargetResources"
        (click)="data.syncData.OverrideTargetResources = !data.syncData.OverrideTargetResources">
        <label class="bz-font-size--body  bz-font-weight--semibold">{{ 'SYNC_DATA.OVERRIDE_LOCALIZATION' | translate}}</label>
      </bzg-checkbox>
    </div>
    <bzg-message *ngIf="errorMessage" [showCloseBtn]="false" [status]="'warning'">
      {{errorMessage | translate}}
    </bzg-message>
  </div>
</div>
